import { IonButton } from "@ionic/react";
import { forwardRef } from "react";
import { usePreferredHaptics } from "@/lib/hooks/use-preferred-haptics";
import { cx } from "@/lib/style/cva.config";

export const Button = forwardRef<HTMLIonButtonElement, React.ComponentProps<typeof IonButton>>(
  function Button(props, ref) {
    const PreferredHaptics = usePreferredHaptics();

    return (
      <IonButton
        ref={ref}
        color="brand"
        {...props}
        className={cx(
          "touch-target m-0 cursor-pointer ion-rounded-lg ion-p-4 part-native:font-bold",
          props.className,
        )}
        onClick={(event) => {
          PreferredHaptics.impact();
          props.onClick?.(event);
        }}
      />
    );
  },
);

/** TODO: YES I KNOW THIS IS A BAD PRACTICE, BUT WE NEED TO MOVE FAST. SORRY FUTURE DEV. */
export const ButtonSecondary = forwardRef<
  HTMLIonButtonElement,
  React.ComponentProps<typeof IonButton>
>(function Button(props, ref) {
  const PreferredHaptics = usePreferredHaptics();

  return (
    <IonButton
      ref={ref}
      color="btn-secondary"
      {...props}
      className={cx(
        "touch-target m-0 cursor-pointer ion-rounded-lg ion-p-4 part-native:font-bold",
        props.className,
      )}
      onClick={(event) => {
        PreferredHaptics.impact();
        props.onClick?.(event);
      }}
    />
  );
});
